import type { IxcProxyvoteV1ProxyJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PROXYVOTE_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/beta-nxt/proxy-vote-job');

export const getProxyVoteJobPath: EntityPathBuilder<IxcProxyvoteV1ProxyJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PROXYVOTE_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${PROXYVOTE_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getProxyVoteJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getProxyVoteJobPath({ kind: 'detail', keys: { jobId } });
}
